import api from './api';
import ErrorService from './errorService';


export const provinceService = {


  getProvincesByRegion: async (idRegion) => {
        try {
          const response = await ErrorService.withTimeout(api.get(`/Province/region/${idRegion}`));
         // const response = await withTimeout(api.get(`/Province/region/16`));
          return response.data;
      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener:', error);
          throw error;
        }
      },

  getAllProvinces: async () => {
    try {
      const response = await ErrorService.withTimeout(api.get(`/Province`));
      // const response = await withTimeout(api.get(`/Province/region/16`));
      return response.data;
  
    } catch (error) {
      ErrorService.handleApiError('Error al obtener:', error);
      throw error;
    }
  },



};